(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('group-session-template', {
                parent: 'entity',
                url: '/group-session-template',
                data: {
                    authorities: [],
                    pageTitle: 'GroupSessionTemplates'
                },
                ncyBreadcrumb: {
                    label: 'Group Sessions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group-session-template/list/group-session-template.html',
                        controller: 'GroupSessionTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                        Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS, access);
                    }]
                }
            })
            .state('group-session-template.new', {
                parent: 'group-session-template',
                url: '/new',
                data: {
                    authorities: []
                },
                ncyBreadcrumb: {
                    label: 'New Template'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/group-session-template/update/group-session-template-dialog.html',
                            controller: 'GroupSessionTemplateDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        facility: CoreService.getCurrentFacility(),
                                        title: null,
                                        description: null,
                                        start: null,
                                        stop: null,
                                        ageBegin: null,
                                        ageEnd: null,
                                        enabled: true,
                                        billable: false,
                                        daysWeek: null,
                                        id: null
                                    };
                                }],
                                filter: ['CoreService', function (CoreService) {
                                    var facility = CoreService.getCurrentFacility();
                                    return {
                                        facilityId: facility.id
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('group-session-template', null, {reload: 'group-session-template'});
                        }, function () {
                            $state.go('group-session-template');
                        });
                    }
                }]
            })
            .state('group-session-template.edit', {
                parent: 'group-session-template',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                ncyBreadcrumb: {
                    label: 'Edit Template'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/group-session-template/update/group-session-template-dialog.html',
                            controller: 'GroupSessionTemplateDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['GroupSessionTemplate', function (GroupSessionTemplate) {
                                    return GroupSessionTemplate.get({id: $stateParams.id}).$promise;
                                }],
                                filter: ['CoreService', function (CoreService) {
                                    var facility = CoreService.getCurrentFacility();
                                    return {
                                        facilityId: facility.id
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('group-session-template', null, {reload: 'group-session-template'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('group-session-template.delete', {
                parent: 'group-session-template',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/group-session-template/group-session-template-delete-dialog.html',
                            controller: 'GroupSessionTemplateDeleteController',
                            controllerAs: 'vm',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: ['GroupSessionTemplate', function (GroupSessionTemplate) {
                                    return GroupSessionTemplate.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('group-session-template', null, {reload: 'group-session-template'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }

})();
